import { Form, Link, Outlet, useLoaderData, NavLink } from "react-router";
import { RiDraftLine } from "react-icons/ri";
import { useNavigate, useParams } from "react-router"

import { useEffect, useRef, useState, } from "react";
import { BiArrowBack, BiX } from "react-icons/bi";
import Select from 'react-select';
import { IoMdMore, IoMdMenu, IoMdHome, IoIosClose, IoIosSettings, IoIosCash, IoIosContract } from "react-icons/io";
import { IoConstructOutline, IoChevronDown, IoChevronUp, IoHomeOutline } from "react-icons/io5";
import { TbLayoutSidebarRightCollapse, TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { useNavigationStore } from "../../store/navigationStore";
import { useBenefitPlanStore } from "../../store/benefitPlanStore";
import centivoLog from '../../assets/centivo-favicon.png';
import Avatar from "../shared/Avatar";
import { useAuthStore } from "../../store/authStore";
import PayorDbStatus from "./PayorDbStatus";

const style = ({ isActive }) => ({ color: isActive ? 'var(--skyDark)' : 'var(--black)', padding: '0rem', textDecoration: 'none', fontWeight: 500, fontSize: '1.1rem' })

const Navbar = ({ }) => {
    const { isAuthenticated } = useAuthStore()
    const navigate = useNavigate()
    const params = useParams();
    const [showRightOptions, setShowRightOptions] = useState(false)
    const [selectedOption, setSelectedOption] = useState(null);
    const menuRef = useRef(null);
    const { activeDraftId, benefitPlans, setBenefitPlanName, addBenefitPlanCompoent, setActiveBenefitPlan } = useBenefitPlanStore();
    const activeBenefitPlanDraft = benefitPlans?.find(bp => bp.draftId == activeDraftId)
    const { isSideBarOpen, setIsSideBarOpen, isChatSidebarOpen, setIsChatSidebarOpen } = useNavigationStore()

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        setSelectedOption({ value: activeBenefitPlanDraft?.draftId, label: activeBenefitPlanDraft?.benefitPlanName, accountId: activeBenefitPlanDraft?.account?.value })

    }, [activeBenefitPlanDraft])

    const handleClickOutside = (event) => {
        // console.log(menuRef.current)
        // console.log(event.target)
        // if (event.target.id !== 'more-menu') {
        //     setShowRightOptions(false);
        // }
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowRightOptions(false);
        }
    };


    const handleChange = (option) => {
        setActiveBenefitPlan({ draftId: option.value })
        setSelectedOption(option);
        if (params?.draftId) {
            navigate(`/bntf-plan-builder/${option.value}`)
        }
        setShowRightOptions(false)
    };


    return (<nav className="navbar" style={{ borderBottom: '1px solid var(--lighterGrey)' }} >
        <div className="left">
            <div
                className="navbar-icon-btn"
                onClick={() => setIsSideBarOpen(!isSideBarOpen)}
                title={isSideBarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
            >
                {isSideBarOpen
                    ? <IoIosClose size="1.25rem" />
                    : <IoMdMenu size="1.1rem" />
                }
            </div>

            <img
                src={isSideBarOpen
                    ? "https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo.svg"
                    : "https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo-c.svg"
                }
                alt="centivo-logo"
                height={18}
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer' }}
            />
        </div>

        <div className="middle" />

        <div ref={menuRef} className="right">
            {/* Right chat-sidebar toggle hidden for now — revisit when the
                global agents drawer comes back. */}
            {false && (
                <div
                    className="navbar-icon-btn"
                    style={{ backgroundColor: isChatSidebarOpen ? 'var(--lightestGrey)' : 'transparent' }}
                    onClick={() => setIsChatSidebarOpen(!isChatSidebarOpen)}
                    title={isChatSidebarOpen ? 'Collapse chat sidebar' : 'Expand chat sidebar'}
                >
                    {isChatSidebarOpen
                        ? <TbLayoutSidebarRightCollapse size="1.15rem" color="var(--skyDark)" />
                        : <TbLayoutSidebarLeftCollapse size="1.15rem" color="var(--darkGrey)" />
                    }
                </div>
            )}
            {/* move to configuration */}
            {/* {activeBenefitPlanDraft ?
                <div className="draft-indicator" onClick={() => {
                    setShowRightOptions(false);
                    navigate(`/bntf-plan-builder/${activeDraftId}`)
                }} >

                    <RiDraftLine size={'1.6rem'} color="var(--green)" />

                    <div style={{ width: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>


                        < p style={{ fontWeight: 600, fontSize: '.8rem' }}>{activeBenefitPlanDraft?.account?.value}</p>
                        {activeBenefitPlanDraft?.benefitPlanName}


                        <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem', padding: '.4rem 0rem 0rem 0rem', }}>
                            <p style={{ fontSize: '.8rem', }}>Comp: {activeBenefitPlanDraft?.benefitPlanComponents?.length}</p>
                            <p style={{ fontSize: '.8rem' }}>Rider: {activeBenefitPlanDraft?.chosenBenefitPlanRiders?.length}</p>
                        </div>
                    </div>

                </div> : <></>} */}
            <NavLink to="/blog" style={style}>Blog</NavLink>
            <PayorDbStatus />
            {/* <NavLink to="/auth/login" style={style}>{isAuthenticated ? 'Logout' : 'LogIn'}</NavLink> */}
            {/* <Avatar src={'https://centivo.com/wp-content/uploads/2023/07/Headshot_AshokSubramanian_Website.jpg'} initials={'KR'} onClick={() => setShowRightOptions(!showRightOptions)} dimension="36px" backgroundColor={'var(--green)'} color={'var(--white)'} /> */}
            {/* <IoMdMore size={'2rem'} onClick={() => setShowRightOptions(!showRightOptions)} style={{ cursor: 'pointer' }} /> */}

            {showRightOptions ? <div

                id="more-menu"
                style={{
                    position: 'absolute',
                    top: 50, right: 0,
                    zIndex: 1000,
                    boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 16px',
                    backgroundColor: 'var(--white)',
                    width: '400px',
                    borderRadius: '.6rem',

                    padding: '1rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                }}>
                {/* <div className="modal-close-button" style={{ cursor: 'pointer' }}>
                    <BiX
                        size={"1.2rem"}
                        onClick={() => setShowRightOptions(false)}
                    />
                </div> */}


                <div>
                    {/* <p className="danger" style={{ cursor: 'pointer' }}>Logout</p> */}
                    <h3 style={{ padding: '0rem 0rem .6rem 0rem' }}>Select Draft</h3>
                    <Select
                        name={'category'}
                        className="react-select-container grey-bg"
                        classNamePrefix="react-select"
                        placeholder={'category...'}
                        // inputRef={field.ref}
                        options={benefitPlans?.map(bpd => ({ value: bpd.draftId, label: bpd.benefitPlanName, account: bpd.account }))}
                        value={selectedOption} // Pass the state variable here
                        components={{ Option: CustomOption, }}
                        // formatOptionLabel={(option) => {
                        //     console.log('option', option)
                        //     return (
                        //         <div>
                        //             <div>{option.label}</div>
                        //             <p>{option.accountId}</p>
                        //             {option.accountId && <small>{option.accountId}</small>}
                        //         </div>
                        //     )
                        // }}
                        onChange={handleChange}
                    // value={options.find((c) => c.value === field.value)}
                    // onChange={(val) => field.onChange(val.value)}
                    />

                </div>

            </div> : <></>}

        </div>



    </nav >)
}

export default Navbar

const CustomOption = (props) => {

    const { innerProps, label, data } = props
    return (
        <div {...innerProps} style={{ padding: '1rem ' }} className="dd-option">

            <p style={{ fontWeight: 600, fontSize: '.8rem' }}>{data?.account?.value}</p>
            <p className="sub-title">{label}</p>
            {/* {data.description && <small>{data.description}</small>} */}
        </div>
    )
};
